import React from "react";
import { Modal } from "react-bootstrap";

import { getFormattedDate } from "helpers";
import { FrontEndPlatformTypes, TerminalProgramTypes } from "types";

import OnlineLink from "../onlineLink";

import styles from "./modal.module.scss";

const DATE_FORMAT = "DD MMMM YYYY";

type MerchantTerminalPreviewModalProps = {
	show: boolean;
	onHide: () => void;
	merchantId: string;
	data: { [key: string]: any };
	showEditBtn: boolean;
};

const MerchantTerminalPreviewModal = ({
	show,
	onHide,
	merchantId,
	data,
	showEditBtn = true,
}: MerchantTerminalPreviewModalProps) => {
	const LabeledValue = ({ label, value }) => (
		<div className="d-flex mt-3">
			<div className={styles.label}>{label}:</div>
			<div className={styles.value}>{value}</div>
		</div>
	);

	const {
		id,
		number,
		terminal_program_type: programType,
		terminal,
		front_end_platforms,
		front_end_mid: frontEndMid,
		tid_v_number: tidVNumber,
		shipping,
		installation,
		other_front_end_platform_name,
	} = data;
	const renderFEplatforms = () => {
		const otherDisplayName = FrontEndPlatformTypes.Other.displayName;
		return front_end_platforms?.map((item, index) => {
			const displayName =
				FrontEndPlatformTypes.getByValue(item)?.displayName;
			const displayText =
				displayName === otherDisplayName
					? other_front_end_platform_name
					: displayName;
			return (
				<span key={item + index} className="pr-2">
					{displayText}
					{index !== front_end_platforms.length - 1 && ","}
				</span>
			);
		});
	};

	const renderSerialsTerminalDevices = () => {
		return terminal?.terminal_devices.reduce(
			(previousValue, currentValue) =>
				previousValue
					? `${previousValue} / ${currentValue?.serial_number}`
					: currentValue?.serial_number,
			"",
		);
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			className={styles.centeredLabelsModal}
		>
			<Modal.Header closeButton className="pb-0">
				<Modal.Title as="h6" className="text-center">
					{`TS - ${number}`}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="d-flex flex-column pt-0">
				<LabeledValue
					label="Program"
					value={
						TerminalProgramTypes.getByValue(programType)
							?.displayName
					}
				/>
				<LabeledValue
					label="POS System / Device"
					value={`${terminal?.manufacturer?.name || ""} ${
						terminal?.model?.name || ""
					}`}
				/>
				<LabeledValue
					label="Front End Platform"
					value={renderFEplatforms()}
				/>
				<LabeledValue label="Front End MID" value={frontEndMid} />
				<LabeledValue label="TID" value={tidVNumber} />
				<LabeledValue
					label="Serial Number"
					value={renderSerialsTerminalDevices()}
				/>
				<LabeledValue
					label="Tracking Number"
					value={shipping?.tracking_number}
				/>
				<LabeledValue
					label="Install Date"
					value={getFormattedDate({
						date: installation?.install_at,
						format: DATE_FORMAT,
					})}
				/>
				<LabeledValue
					label="Uninstall Date"
					value={getFormattedDate({
						date: installation?.uninstall_at,
						format: DATE_FORMAT,
					})}
				/>
				<LabeledValue label="Vendor" value={shipping?.vendor} />
			</Modal.Body>
			{showEditBtn && (
				<Modal.Footer className="d-flex justify-content-center">
					<OnlineLink
						to={`/merchant/list/info/${merchantId}/terminal-solutions/${id}/edit`}
						className="btn btn-primary btn-min-width"
						onClick={onHide}
					>
						Edit
					</OnlineLink>
				</Modal.Footer>
			)}
		</Modal>
	);
};

export default MerchantTerminalPreviewModal;
